// extracted by mini-css-extract-plugin
export var hidden = "_6x-1";
export var visible = "_6x-0";